module.exports = __webpack_public_path__ + "site/img/17.66390b1c.jpg";